import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { AgreementService } from '../agreement.service';
import { Subject } from 'rxjs';
import { AgreementUserLogModel } from '@fi-app/agreement/agreement-user-log.model';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { ObjectTypes } from '@fi-shared/types';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';

@Component({
    selector: 'fi-agreement-view-accepted',
    templateUrl: './agreement-view-accepted.component.html',
    styleUrls: ['./agreement-view-accepted.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-agreement-view-accepted' },
    standalone: false,
})
export class FiAgreementViewAcceptedComponent
    extends FiInfiniteScrollDataSource<AgreementUserLogModel>
    implements OnInit, OnDestroy
{
    defaultSortColumnName = 'AcceptedByUserName';
    defaultSortDirection = true;
    objectType = ObjectTypes.Agreement;
    itemsListType = FiItemsListType.AgreementViewAccepted;

    @Input() agreement;

    constructor(
        private loadingService: LoadingService,
        private agreementService: AgreementService,
        injector: Injector,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.reloadData();
    }

    getListData(): Promise<AgreementUserLogModel[]> {
        return this.loadingService.trackPromise(this.agreementService.GetAgreementUserLogs(this.agreement));
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    protected readonly FiStateNames = FiStateNames;
}
